<div
  *ngIf="settings"
  class="form-group align-self-end {{ getInputControlClasses() }}  {{
    settings.class
  }}"
>
  <label
    *ngIf="settings.label"
    for="input-{{ settings.fieldName.toString() | titlecase }}"
  >
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div
    [ngClass]="{
      'd-flex input-group': true
    }"
    [class]="settings.customInputClass"
  >
    <textarea
      id="input{{ settings.fieldName | titlecase }}"
      name="input{{ settings.fieldName | titlecase }}"
      class="form-control {{
        control && !!control.invalid ? 'ng-invalid' : 'ng-valid'
      }}
      {{ disabled ? 'input-only' : '' }}
      {{ required ? 'required' : '' }}  {{
        data && settings.showFieldHasValue === true ? 'filled-out' : ''
      }}"
      rows="4"
      cols="50"
      [placeholder]="settings.placeholder ? settings.placeholder : ''"
      [required]="required"
      [disabled]="disabled"
      [(ngModel)]="data"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
    ></textarea>
    <div class="input-group-append">
      <button
        type="button"
        class="input-group-text"
        *ngIf="!settings.hideResetInput && !disabled"
        tabindex="-1"
        (click)="onClearInput()"
        [disabled]="disabled"
      >
        <span class="oi oi-x"></span>
      </button>
    </div>
  </div>
  <div class="error-message" *ngIf="showError">
    {{ errors[0] }}
  </div>
</div>
